import { Box, Typography } from '@mui/material'

import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'

const PermissionItem = ({ label, enabled }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      p: 2,
      borderRadius: 2,
      bgcolor: enabled ? 'rgba(76,175,80,.12)' : 'rgba(255,255,255,.03)',
      border: '1px solid',
      borderColor: enabled ? 'rgba(76,175,80,.35)' : 'rgba(255,255,255,.06)',
    }}>
    {enabled ? (
      <CheckCircleRoundedIcon
        sx={{
          color: '#4caf50',
          fontSize: 22,
        }}
      />
    ) : (
      <CancelRoundedIcon
        sx={{
          color: 'text.secondary',
          opacity: 0.45,
          fontSize: 22,
        }}
      />
    )}

    <Typography
      sx={{
        fontWeight: 500,
      }}>
      {label}
    </Typography>
  </Box>
)

const UserPermissions = ({ userRole }) => (
  <Box
    sx={{
      mb: 1,
      borderRadius: 3,
      border: '1px solid rgba(255,255,255,.08)',
      boxShadow: '0 12px 35px rgba(0,0,0,.35)',
      p: 2,
    }}>
    <Typography
      variant='h6'
      sx={{
        mb: 1,
        fontWeight: 600,
      }}>
      Permissions
    </Typography>

    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5,1fr)',
        gap: 2,
      }}>
      <PermissionItem label='Administrator' enabled={userRole?.roleAttributes?.permissions?.admin} />
      <PermissionItem label='Create' enabled={userRole?.roleAttributes?.permissions?.canCreate} />
      <PermissionItem label='Edit' enabled={userRole?.roleAttributes?.permissions?.canEdit} />
      <PermissionItem label='Delete' enabled={userRole?.roleAttributes?.permissions?.canDelete} />
      <PermissionItem label='Approve' enabled={userRole?.roleAttributes?.permissions?.canApprove} />
    </Box>
  </Box>
)

export default UserPermissions
